export function saveHistoryIfPossible(field) {
    if (field.saveHistory && typeof field.saveHistory === 'function') {
        field.saveHistory();
    }
}
